// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__3gcrI","ModalHeader":"Modal_ModalHeader__3BgJF","ModalContent":"Modal_ModalContent__s5Nyk","ModalFooter":"Modal_ModalFooter__121Kh"};